/**
 * 颜色
 */
export enum Colors {
  Primary = '#007aff',
  Secondary = '#4a90e2',
  Danger = '#f35656',
  Warning = '#fa8c16',
  Success = '#33c97e',
  Background = '#f4f7fc',
  BackgroundActive = '#F4F7FC',
  BackgroundYellow = '#ff6b00',
  Border = '#e2e7f1',
  Mask = 'rgba(0,0,0,0.4)',
  Font = '#454553',
  FontLighten1 = '#9a9aa4',
  FontLighten2 = '#d5d9e1',
  FontPlaceholder = '#9A9A9A',
}
